import { c as _c } from "react/compiler-runtime";
import { Checkbox, Text, FontWeights } from "@flat-ui";
import { PALETTE_VARS } from "@styles/palette-vars";
import { Box } from "@mui-wrapper";
import { feedbackControlWrapperSx, feedbackOptionRowSx } from "@components/analytics/in-house/feedback/analytics-feedback-helper";
import { AnalyticsFeedbackStepLayout } from "@components/analytics/in-house/feedback/analytics-feedback-step";
import { runtimeConfig } from "@src/runtime-config";
/** Optional consent-to-contact step. */
function AnalyticsFeedbackStep4Content(t0) {
  const $ = _c(17);
  const {
    answers,
    onAnswersChange
  } = t0;
  let t1;
  if ($[0] !== answers.hasOptedInToContact || $[1] !== onAnswersChange) {
    t1 = () => onAnswersChange({
      hasOptedInToContact: !answers.hasOptedInToContact
    });
    $[0] = answers.hasOptedInToContact;
    $[1] = onAnswersChange;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = answers.hasOptedInToContact ? PALETTE_VARS.Chip.primary.outline : "divider";
  const t3 = answers.hasOptedInToContact ? PALETTE_VARS.Chip.primary.background : "transparent";
  let t4;
  if ($[3] !== t2 || $[4] !== t3) {
    t4 = {
      ...feedbackOptionRowSx,
      borderColor: t2,
      backgroundColor: t3
    };
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== answers.hasOptedInToContact) {
    t5 = <Box sx={feedbackControlWrapperSx}><Checkbox checked={answers.hasOptedInToContact} readOnly={true} /></Box>;
    $[6] = answers.hasOptedInToContact;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Text variant="bodyM">I agree to be contacted about my feedback</Text>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== answers.hasOptedInToContact || $[10] !== t1 || $[11] !== t4 || $[12] !== t5) {
    t7 = <Box role="checkbox" aria-checked={answers.hasOptedInToContact} onClick={t1} sx={t4}>{t5}{t6}</Box>;
    $[9] = answers.hasOptedInToContact;
    $[10] = t1;
    $[11] = t4;
    $[12] = t5;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Text variant="bodyS" color="text.secondary">If you need help with a specific problem, please contact{" "}<Box component="span" sx={{
        color: "primary.main",
        fontWeight: FontWeights.SemiBold
      }}><var>{runtimeConfig.mailSupportAddress}</var></Box></Text>;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t7) {
    t9 = <AnalyticsFeedbackStepLayout title="Open to a 20-min call to go deeper?" subtext="We'd love to learn from you directly. Totally optional.">{t7}{t8}</AnalyticsFeedbackStepLayout>;
    $[15] = t7;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
}

/** Step definition registered in the survey flow. */
export const analyticsFeedbackStep4 = {
  stepName: "contact",
  StepComponent: AnalyticsFeedbackStep4Content,
  isValid: () => true
};